export const CREDITS_PER_SKU = 100;
export const SPONSORED_PREFIX = "sponsored:";

export function creditsToSkus(credits) {
  return Math.floor((Number(credits) || 0) / CREDITS_PER_SKU);
}

export function skusToCredits(skus) {
  return (Number(skus) || 0) * CREDITS_PER_SKU;
}

export function spendableSkus(creditTotals) {
  if (!creditTotals?.length) return 0;
  return creditsToSkus(
    creditTotals.reduce((sum, t) => sum + (t.creditsLeft || 0), 0),
  );
}

export function isSponsoredCreditType(type) {
  return typeof type === "string" && type.startsWith(SPONSORED_PREFIX);
}

export function marketplaceIdFromCreditType(type) {
  return isSponsoredCreditType(type) ? type.slice(SPONSORED_PREFIX.length) : null;
}

export function skusByKind(creditTotals) {
  let sponsored = 0;
  let paid = 0;
  for (const total of creditTotals || []) {
    const left = total.creditsLeft || 0;
    if (isSponsoredCreditType(total.creditType)) sponsored += left;
    else paid += left;
  }
  return {
    sponsored: creditsToSkus(sponsored),
    paid: creditsToSkus(paid),
  };
}

export function destinationName(tenantProfile, marketplaces) {
  if (tenantProfile?.partnerName) return tenantProfile.partnerName;
  const id = tenantProfile?.partnerMarketplaceId;
  if (!id) return null;
  return marketplaces?.find((m) => m.value === id)?.label || null;
}

export function creditTypeLabel(type, marketplaces) {
  if (!type || type === "default") return "Paid SKUs";
  const id = marketplaceIdFromCreditType(type);
  if (!id) return type;
  const name = marketplaces?.find((m) => m.value === id)?.label;
  return name ? `${name} trial SKUs` : "Partner trial SKUs";
}

export function skuBadgeTooltip(tenantProfile, marketplaces) {
  const dest = destinationName(tenantProfile, marketplaces);
  const { sponsored, paid } = skusByKind(tenantProfile?.creditTotals);
  if (sponsored <= 0) return null;
  const from = dest || "your partner";
  const lock = dest
    ? `Only for ${dest} listings.`
    : "Only for that marketplace.";
  const paidBit =
    paid > 0
      ? ` ${paid.toLocaleString()} paid SKUs work on any marketplace.`
      : "";
  return `${sponsored.toLocaleString()} trial SKUs from ${from}. ${lock}${paidBit}`;
}
